// ============================================
// DRAFT TEXT MANAGER
// ============================================
// Manages random selection of draft texts without repetition

import { DRAFT_TEXTS } from '../config/gameConfig';

class DraftTextManager {
  constructor() {
    this.availableTexts = [...DRAFT_TEXTS];
    this.usedTexts = [];
  }

  // Get a random text that hasn't been used yet
  getRandomText() {
    // If all texts have been used, reset the pool
    if (this.availableTexts.length === 0) {
      console.log('All draft texts used, resetting pool');
      this.availableTexts = [...DRAFT_TEXTS];
      this.usedTexts = [];
    }

    // Pick random text from available pool
    const randomIndex = Math.floor(Math.random() * this.availableTexts.length);
    const selectedText = this.availableTexts[randomIndex];

    // Move text from available to used
    this.availableTexts.splice(randomIndex, 1);
    this.usedTexts.push(selectedText);

    return selectedText;
  }

  // Get multiple random texts
  getRandomTexts(count) {
    const texts = [];
    for (let i = 0; i < count; i++) {
      texts.push(this.getRandomText());
    }
    return texts;
  }

  // Reset the manager (call when starting new game)
  reset() {
    this.availableTexts = [...DRAFT_TEXTS];
    this.usedTexts = [];
  }

  // Get stats for debugging
  getStats() {
    return {
      available: this.availableTexts.length,
      used: this.usedTexts.length,
      total: DRAFT_TEXTS.length,
    };
  }
}

// Export singleton instance
export const draftTextManager = new DraftTextManager();